import {FC, Card, PropsWithChildren} from 'external/react'
import Icon from 'external/fortawesome'

import ButtonBack from 'components/ButtonBack'
import BasicLayout from './BasicLayout'

const PayoutsContainer: FC<PropsWithChildren> = props => {
    const {children} = props
    return (
        <BasicLayout>
            <Card.Header className='card--header d-flex'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path='/accounting' />
                </div>
                <div className='ms-2' style={{ fontSize: '31px' }}>
                    <Icon name='faDollar' /> Pagos
                </div>
            </Card.Header> 
            {children}
        </BasicLayout>
    )
}

export {PayoutsContainer as default}